import { getColors } from "../../utils/color-combinations"
import BaseHero from "components/BaseHero"
import styles from "./PageHero.module.scss"
import cx from "classnames"

const PageHero = ({ data, className = "", style = {} }) => {
  const colors = getColors(data)

  const {
    title,
    headline,
    subtitle,
    subtext,
    letter,
    title_image: image,
    locale,
  } = data

  return (
    <section className={cx(styles.section, className)} style={style}>
      <BaseHero
        headline={headline || title}
        subline={subtitle}
        subtext={subtext}
        image={image}
        colors={colors}
        letter={letter}
        locale={locale}
        cornersRounded={[1, 0, 0, 0]}
      />
    </section>
  )
}

export default PageHero
